import * as React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardHeader,
  CardTitle,
  CardImg,
  CardBody,
  CardFooter,
  Button,
  Row,
  Col
} from "shards-react"

import ProgrammePreview from "../components/programmePreview"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"
import { routify } from "../js/routify"

class AdmissionsPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      country: getCountry(this.props.pageContext.countryCode),
      routes: require("../data/routes.json")
    }
  }

  render() {
    const Image = () => (
      <img
        src="https://www.mona.uwi.edu/sites/default/files/uwi/stepByStepGuideToApplying.png"
        style={{ width: "100%" }}
      />
    )

    return (
      <Layout countryCode={this.props.pageContext.countryCode || "JM"}>
        <SEO
          countryCode={this.props.pageContext.countryCode || "JM"}
          title="Admissions"
          description=""
        />

        <MobileView>
          <Image />
        </MobileView>

        <Container>
          <Breadcrumb>
            <BreadcrumbItem>
              <a
                href={routify(
                  this.props.pageContext.countryCode || "JM",
                  this.state.routes.home
                )}
              >
                Home
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>Admissions</BreadcrumbItem>
          </Breadcrumb>

          <Row>
            <Col md={6}>
              <BrowserView>
                <Image />
                <br />
                <br />
              </BrowserView>

              <h4>How to Apply</h4>

              <p></p>

              <br />
              <br />
            </Col>
            <Col md={6}>
              <ProgrammePreview
                showLabel
                countryCode={this.props.pageContext.countryCode || "JM"}
              />
            </Col>
          </Row>
        </Container>
      </Layout>
    )
  }
}

export default AdmissionsPage
